import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children, adminOnly = false }) {
  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario'));

  if (!token || !usuario) {
    return <Navigate to="/login" />;
  }
  if (adminOnly && !usuario.administrador) {
    return <Navigate to="/socio" />;
  }
  if (!adminOnly && usuario.administrador) {
    return <Navigate to="/admin" />;
  }
  return children;
}

export default PrivateRoute; 